/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2021, Bulb Inc.  For more information, please email contact@hellobulb.com.
 *
 *                _
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
 *
 *
 */

/**
 * @module bulb-video/bulbvideocommand
 */

import { Command, ModelWriter } from 'ckeditor5';

/**
 * The bulb video command, the actual insert capabilities of the plugin.
 *
 * @extends Command
 */
export class InsertBulbVideoCommand extends Command {

  public override execute(blockDetails, placeholderElement, insertPosition, videoType): void {
    this.editor.model.change((writer: ModelWriter) => {
      // Check for an insertPosition, this would only happen if we had to transcode the asset and had the
      // placeholder and need to put this exactly where the placeholder was.
      if (insertPosition) {
        this.editor.model.insertContent(
          InsertBulbVideoCommand.createVideoBlock(writer, blockDetails, videoType),
          insertPosition,
        );
      } else {
        this.editor.model.insertContent(InsertBulbVideoCommand.createVideoBlock(writer, blockDetails, videoType));
      }

      CKEBulbData.service.ckeStateService.insertParagraphSubject.next(true);

      if (placeholderElement) {
        writer.remove(placeholderElement);
      }
    });
  }

  public override refresh(): void {
    const { model } = this.editor;
    const { selection } = model.document;
    const allowedIn = model.schema.findAllowedParent(selection.getFirstPosition(), 'video');

    this.isEnabled = allowedIn !== null;
  }

  /**
   * Helper function to create a video block within cke.
   *
   * @param writer Instance of model writer.
   * @param blockDetails Content block details.
   * @param videoType whether it can play video instantly.
   * @returns {*}
   */
  private static createVideoBlock(writer, blockDetails, videoType) {
    return writer.createElement(
      'video',
      { 'bulb-block-id': blockDetails.id, 'bulb-block-version': blockDetails.version, 'video-type': videoType },
    );
  }
}
